module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.rectre('/')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.rectre('/paket-mapel')
      }
    }
  }, [_vm._v("Bimbel Online")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Paket Mata Pelajaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.packData.name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.showForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('b', [_vm._v("Tambah Bab")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-bab"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, _vm._l((_vm.packData.sections), function(item, index) {
    return _c('bab', {
      key: index,
      attrs: {
        "indexProp": index,
        "datalist": item,
        "mapelid": _vm.packData
      },
      on: {
        "editBab": function($event) {
          return _vm.detailBab($event)
        },
        "throwEdit": function($event) {
          return _vm.editContent($event)
        },
        "reload": function($event) {
          return _vm.loadData()
        },
        "addingcontent": function($event) {
          return _vm.addContentButton($event)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addBabModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "addBabModalTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.postState === 0) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "addBabModalTitle"
    }
  }, [_c('b', [_vm._v("Tambah Bab")])]) : _vm._e(), _vm._v(" "), (_vm.postState === 1) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "addBabModalTitle"
    }
  }, [_c('b', [_vm._v("Update Bab")])]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Bab")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bab_name),
      expression: "bab_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bab_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listBab), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.nama
      }
    }, [_vm._v(_vm._s(item.nama))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Start Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_time),
      expression: "start_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "startTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "start_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("End Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "end_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_time),
      expression: "end_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_free),
      expression: "is_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.is_free) ? _vm._i(_vm.is_free, null) > -1 : (_vm.is_free)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.is_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.is_free = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.is_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.is_free = $$c
        }
      }
    }
  }), _vm._v("  "), _c('b', [_vm._v("Gratis")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.postState === 0) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDataBab()
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e(), _vm._v(" "), (_vm.postState === 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editDataBab()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'kontenmodal',
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLongTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.idContent === null) ? _c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_c('b', [_vm._v("Tambah Konten ")])]) : _vm._e(), _vm._v(" "), (_vm.idContent !== null) ? _c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_c('b', [_vm._v("Update Konten ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.hideFormContent()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 1 ? 'nav-link active' : _vm.type_id !== 1 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "video-tab",
      "data-toggle": "tab",
      "href": "#video",
      "role": "tab",
      "aria-controls": "video",
      "aria-selected": "true"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 1 : ''
      }
    }
  }, [_vm._v("Video")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 2 ? 'nav-link active' : _vm.type_id !== 2 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "materi-tab",
      "data-toggle": "tab",
      "href": "#materi",
      "role": "tab",
      "aria-controls": "materi",
      "aria-selected": "false"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 2 : ''
      }
    }
  }, [_vm._v("Materi")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 3 ? 'nav-link active' : _vm.type_id !== 3 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "latihan-tab",
      "data-toggle": "tab",
      "href": "#latihan",
      "role": "tab",
      "aria-controls": "latihan",
      "aria-selected": "false"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 3 : ''
      }
    }
  }, [_vm._v("Latihan Soal")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 4 ? 'nav-link active' : _vm.type_id !== 4 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "terjadwal-tab",
      "data-toggle": "tab",
      "href": "#terjadwal",
      "role": "tab",
      "aria-controls": "terjadwal",
      "aria-selected": "false"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 4 : ''
      }
    }
  }, [_vm._v("Tryout Terjadwal")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [(_vm.type_id === 1) ? _c('div', [(this.errorVideo.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorVideo), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video_judul),
      expression: "video_judul"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.video_judul = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listVideo), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul Alternatif")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video_judul_alt),
      expression: "video_judul_alt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.video_judul_alt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video_judul_alt = $event.target.value
      }
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.type_id === 2) ? _c('div', [(this.errorMateri.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorMateri), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materi_judul),
      expression: "materi_judul"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.materi_judul)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.materi_judul = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload")]), _vm._v(" "), (_vm.showLoader) ? _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": _vm.loading
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.showLoader) ? _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.file_url !== '') ? _c('a', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "href": _vm.file_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("  " + _vm._s(_vm.convertURL(_vm.file_url)))]) : _vm._e(), _vm._v(" "), (_vm.file_url !== '') ? _c('br') : _vm._e(), _vm._v(" "), (_vm.file_url !== '') ? _c('br') : _vm._e(), _vm._v(" "), _c('span', [_c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file",
      "placeholder": [
        ['ganti file']
      ]
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), (_vm.validFile === 1) ? _c('div', {
    staticStyle: {
      "color": "green",
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("File is Valid and uploaded!")]) : _vm._e(), _vm._v(" "), (_vm.validFile === 2) ? _c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("upload gagal, pastikan jenis file yang dipilih adalah pdf")]) : _vm._e()]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.type_id === 3) ? _c('div', [(this.errorSoal.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorSoal), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bab")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('app-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "placeholder": "Cari Bab",
      "data": _vm.babList,
      "value": _vm.autoValueBab
    },
    on: {
      "selected": function($event) {
        return _vm.assignBab($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Sub Bab")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('app-autocomplete', {
    ref: "subbabautocomplete",
    attrs: {
      "placeholder": "Cari Sub Bab",
      "data": _vm.subBabList,
      "value": _vm.autoValueSubBab
    },
    on: {
      "selected": function($event) {
        return _vm.assignSubBab($event)
      }
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tryout",
      "role": "tabpanel",
      "aria-labelledby": "tryout-tab"
    }
  }, [(this.errorTryout.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorTryout), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeTO),
      expression: "typeTO"
    }],
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeTO = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SBMPTN"
    }
  }, [_vm._v("SBMPTN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_NASIONAL"
    }
  }, [_vm._v("UJIAN AKHIR NASIONAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_SEKOLAH"
    }
  }, [_vm._v("UJIAN AKHIR SEKOLAH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_SEKOLAH"
    }
  }, [_vm._v("UJIAN SEKOLAH")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Varian *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variant),
      expression: "variant"
    }],
    attrs: {
      "name": "variant"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.variant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "INSTANT_COMPLETE"
    }
  }, [_vm._v("INSTANT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openTO
    }
  }, [_vm._v("Klik Untuk Pilih Tryout")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id && _vm.TOFromEdit === '') ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.dependencyName))])]) : _vm._e(), _vm._v(" "), (_vm.TOFromEdit !== '' && _vm.idContent !== null) ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.TOFromEdit))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("hapus")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.type_id === 4) ? _c('div', [(this.errorTerjadwal.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorTerjadwal), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeTO),
      expression: "typeTO"
    }],
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeTO = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SBMPTN"
    }
  }, [_vm._v("SBMPTN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_NASIONAL"
    }
  }, [_vm._v("UJIAN AKHIR NASIONAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_SEKOLAH"
    }
  }, [_vm._v("UJIAN AKHIR SEKOLAH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_SEKOLAH"
    }
  }, [_vm._v("UJIAN SEKOLAH")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Varian *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variant),
      expression: "variant"
    }],
    attrs: {
      "name": "variant"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.variant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SCHEDULED"
    }
  }, [_vm._v("BERAGENDA")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.idContent === null) ? _c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openTO
    }
  }, [_vm._v("Klik Untuk Pilih Tryout")]) : _vm._e(), _vm._v(" "), (_vm.idContent !== null) ? _c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openTO
    }
  }, [_vm._v("Ubah TO ...")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id && _vm.TOFromEdit === '') ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.dependencyName))])]) : _vm._e(), _vm._v(" "), (_vm.TOFromEdit !== '' && _vm.idContent !== null) ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.TOFromEdit))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("hapus")]) : _vm._e()])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.idContent === null) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveContent(_vm.type_id)
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e(), _vm._v(" "), (_vm.idContent !== null) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateKonten(_vm.type_id)
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])]), _vm._v(" "), _c('app-tryoutgroupchooser', {
    ref: "groupChooser",
    attrs: {
      "params": {
        grade: _vm.kelas,
        status: 'PUBLISHED',
        type: _vm.typeTO,
        variant: _vm.variant
      }
    },
    on: {
      "dblClicked": function($event) {
        return _vm.addDependency($event)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d150a1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bimbel_online/paket_mapel/PaketMapel.vue
// module id = 1382
// module chunks = 0